import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import './index.css';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={options}
      >
        <App />
      </PostHogProvider>
    </StrictMode>
  );
}
